import { Box } from '@material-ui/core'
import Step from '@material-ui/core/Step'
import StepConnector from '@material-ui/core/StepConnector'
import { StepIconProps } from '@material-ui/core/StepIcon'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import CheckIcon from '@material-ui/icons/Check'
import { Maybe } from '@ts/operations'
import clsx from 'clsx'
import { DateTime } from 'luxon'
import React, { useEffect } from 'react'

import ReleasePhaseDate from './ReleasePhaseDate'
import ReleasePhaseTag from './ReleasePhaseTag'

const useStyles = makeStyles({
  labelContainer: {
    width: 'auto',
  },
  root: {
    backgroundColor: 'transparent',
    padding: 0,
    width: 'auto',
  },
  step: {
    padding: '0 3em 0',
    whiteSpace: 'nowrap',
    width: '10em',
  },
  stepper: {
    overflow: 'auto',
  },
  unstyledLink: {
    textDecoration: 'none',
  },
})

const Connector = withStyles(theme => ({
  active: {
    '& $line': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  alternativeLabel: {
    left: 'calc(-50% + 0.4em)',
    right: 'calc(50% + 0.4em)',
    top: '0.63em',
  },
  completed: {
    '& $line': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  line: {
    backgroundColor: theme.palette.grey[300],
    border: 0,
    borderRadius: '0.063em',
    height: '0.188em',
  },
}))(StepConnector)

const useStepIconStyles = makeStyles(theme => ({
  active: {
    color: theme.palette.secondary.main,
  },
  circle: {
    backgroundColor: 'currentColor',
    borderRadius: '50%',
    height: '.55em',
    width: '.55em',
  },
  circleActive: {
    height: '1.4em',
    width: '1.4em',
    zIndex: 1,
  },
  completed: {
    color: theme.palette.secondary.main,
    fontSize: '1.125em',
    zIndex: 1,
  },
  icon: {
    color: theme.palette.common.white,
    display: 'block',
    fontSize: '1rem',
    height: '1.3em',
    margin: 'auto',
  },
  pending: {
    color: theme.palette.grey[300],
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    height: '1.375em',
  },
}))

const StepIcon = (props: StepIconProps) => {
  const classes = useStepIconStyles()
  const { active, completed } = props

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
        [classes.pending]: !active && !completed,
      })}
    >
      <div className={clsx(classes.circle, { [classes.circleActive]: active })}>
        {active && <CheckIcon className={classes.icon} />}
      </div>
    </div>
  )
}

type ReleasePhaseListProps = {
  phases: {
    active: boolean
    endsAt: DateTime
    id: Maybe<string>
    name: string
  }[]
}

const ReleasePhaseList = ({ phases }: ReleasePhaseListProps) => {
  const classes = useStyles()
  const activeIndex = phases.findIndex(phase => phase.active)

  useEffect(() => {
    const selectedPhaseElement = document.getElementById('selected')
    if (selectedPhaseElement) {
      selectedPhaseElement.scrollIntoView({ block: 'end', inline: 'center' })
    }
  })

  return (
    <Box className={classes.stepper} maxWidth={1275} mx="auto" pt={4}>
      <Stepper
        alternativeLabel
        activeStep={activeIndex}
        className={classes.root}
        connector={<Connector />}
      >
        {phases.map(phase => (
          <Step key={phase.name} className={classes.step}>
            <StepLabel
              StepIconComponent={StepIcon}
              classes={{ labelContainer: classes.labelContainer }}
              id={phase.active ? 'selected' : undefined}
            >
              <ReleasePhaseTag endsAt={phase.endsAt} selected={phase.active} text={phase.name} />
              {phase.endsAt && <ReleasePhaseDate endsAt={phase.endsAt} selected={phase.active} />}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}

export default ReleasePhaseList
